import { render } from "./editorial-team.vue?vue&type=template&id=468fd2f8&lang=html"
import script from "./editorial-team.vue?vue&type=script&lang=js"
export * from "./editorial-team.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__